<template>
  <div>
    <div id="perform-results" class="search-results search-results__section component-padding bg-color-white fadeInSimple"
      v-show="matchCurrentTab('perform') && performCount > 0 && !isSearchEmpty">
      <div class="row">
        <div class="col-12">
          <h3 class="type-h3 display-inline-block no-bottom-margin padding-right-m">Perform</h3>
          <a class="type-link type-regular" :href="formattedSearchLink('perform', term)">View all ({{performCount}})</a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <ul class="search-results__list unstyled-list flex flex-wrap">
            <GlobalSearchPerformResults :result="performTitle" v-for="performTitle in performTitles.slice(0, 16)" :key="performTitle.Id" />
          </ul>
          <div v-if="performCount > 8">
            <a class="type-link type-link--arrow type-regular add-top-margin" :href="formattedSearchLink('perform', term)">View all ({{performCount}}) Results for "{{term}}" in Perform</a>
          </div>
        </div>
      </div>
    </div>
    <div id="shop-results" class="search-results search-results__section component-padding bg-color-white fadeInSimple"
      v-show="matchCurrentTab('shop') && shopCount > 0 && !isSearchEmpty">
      <div class="row">
        <div class="col-12">
          <h3 class="type-h3 display-inline-block no-bottom-margin padding-right-m">Shop</h3>
          <a class="type-link type-regular" :href="formattedSearchLink('shop', term)">View all ({{shopCount}})</a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <ul class="search-results__list unstyled-list flex flex-wrap">
            <GlobalSearchShopResults :result="shopTitle" v-for="shopTitle in shopTitles.slice(0, 16)" :key="shopTitle.Id" />
          </ul>
          <div v-if="shopCount > 8">
            <a class="type-link type-link--arrow type-regular add-top-margin" :href="formattedSearchLink('shop', term)">View all ({{shopCount}}) Results for "{{term}}" in Shop</a>
          </div>
        </div>
      </div>
    </div>
    <div
      id="authors-results"
      class="search-results search-results__section component-padding bg-color-white fadeInSimple"
      v-show="matchCurrentTab('author') && authorsCount > 0 && !isSearchEmpty">
      <div class="row">
        <div class="col-12">
          <h3 class="type-h3 display-inline-block no-bottom-margin padding-right-m">Authors</h3>
          <a class="type-link type-regular" :href="formattedSearchLink('authors', term)">View all ({{authorsCount}})</a>
        </div>
      </div>
      <div class="row">
        <div class="col-9 authors-container">
          <ul class="search-results__list unstyled-list flex flex-wrap">
            <GlobalSearchAuthorResults :result="author" v-for="author in authors.slice(0, 8)" :key="author.Id" />
          </ul>
          <div v-if="authorsCount > 8">
            <a class="type-link type-link--arrow type-regular add-top-margin" :href="formattedSearchLink('authors', term)">See all ({{authorsCount}}) Results for "{{term}}" in Author </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { mapState } from 'vuex';

    import GlobalSearchPerformResults from './GlobalSearchPerformResults.vue';
    import GlobalSearchShopResults from './GlobalSearchShopResults.vue';
    import GlobalSearchAuthorResults from './GlobalSearchAuthorResults.vue';

    export default {
        name: 'GlobalSearchResults',
        components: {
            GlobalSearchPerformResults,
            GlobalSearchShopResults,
            GlobalSearchAuthorResults,
        },
        data() {
          return {
            activeTab: '',
          }
        },
        mounted() {
          this.activeTab = 'perform';
        },
        watch: {
          currentTab() {
            this.activeTab = this.currentTab;
          }
        },
        methods: {
            formattedSearchLink(category, term) {
                const formattedTerm = encodeURIComponent(term);
                if (category != 'authors' && this.$store.state.globalSearch.author) {
                  return `/${category}/catalog?author=${this.$store.state.globalSearch.author}`;
                } else {
                  return `/${category}/catalog?query=${formattedTerm}`;
                }

            },
            matchCurrentTab(category) {
              return this.activeTab === category;
            },
        },
        computed: {
            ...mapState({
                term: state => state.globalSearch.term,
                author: state => state.globalSearch.author,
                isSearchEmpty: state => state.globalSearch.isSearchEmpty,
                results: state => state.globalSearch.results,
                performTitles: state => state.globalSearch.results.performTitles,
                shopTitles: state => state.globalSearch.results.shopTitles,
                authors: state => state.globalSearch.results.authors,
                resultsCounts: state => state.globalSearch.resultsCounts,
                performCount: state => state.globalSearch.resultsCounts.performCount,
                shopCount: state => state.globalSearch.resultsCounts.shopCount,
                authorsCount: state => state.globalSearch.resultsCounts.authorsCount,
                totalCount: state => state.globalSearch.resultsCounts.totalCount,
                currentTab: state => state.globalSearch.currentTab,
            })
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/GlobalSearchResults.vue